import type { CrbMarketingUserOnboardingFormDataV1_2, InputMarketingOrgRegistration } from '@gcv/shared';
import { UserInterestFeatheryInterestMap } from '@gcv/shared';
import { inject, injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';

import { UsersApi } from 'api';
import { UserStore } from 'stores/UserStore';

export interface PM {
  formData: CrbMarketingUserOnboardingFormDataV1_2;
}

@injectable()
export class CrbWelcomeRepo {
  @inject(UsersApi)
  usersApi: UsersApi;

  @inject(UserStore)
  userStore: UserStore;

  constructor() {
    makeAutoObservable(this);
  }

  programmersModel: PM = { formData: {} };

  public load = async () => {
    let form_response = (await this.usersApi.getUserFeatheryFormResponse(this.userStore.user.id))
      ?.form_response;

    // if they haven't filled out interests, but have interests saved on the user, prefill form
    if (!form_response?.interests_1 && this.userStore.user.interests) {
      const interests = this.userStore.user.interests.map((i) => UserInterestFeatheryInterestMap[i]);
      form_response = { ...form_response, interests_1: interests };
    }

    this.programmersModel = { ...this.programmersModel, formData: form_response };
  };

  public updateUserFeatheryFormResponse = async (formResponse: CrbMarketingUserOnboardingFormDataV1_2) => {
    const comment = formResponse['comment_1'] ?? '';
    formResponse['comment_1'] = comment.trim();

    return this.usersApi.updateUserFeatheryFormResponse(this.userStore.user.id, formResponse);
  };

  public registerMarketingUserOrg = async (data: InputMarketingOrgRegistration) =>
    this.usersApi.registerMarketingUserOrg(this.userStore.user.id, data);
}
